import Vue from 'vue';
import {ApckPortletApexChart} from "../portlet";

export const ApckPortletOWASP = /*#__PURE__*/ ApckPortletApexChart.extend({
    props: {
        ctype: {
            type: String,
            default: "owaspportlet"
        },
        title: {
            type: String,
            default: "OWASP Top 10"
        },
        size: {
            type: String,
            default: "md"
        },
        description: {
            type: String,
            default: "Shows a chart of vulnerabilities discovered and listed in the OWASP top 10"
        },
        src: {
            type: String,
            default: "/owasp"
        },
        chartType: {
            type: String,
            default: 'pie',
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: true
                    },
                    title: {
                        text: "OWASP 2025",
                        align: "center",
                    },
                    chart: {
                        stacked: true,
                        toolbar: {
                            tools: {
                                download: false,
                            },
                        },
                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: false
                        }
                    },
                    noData: {
                        text: "No Top 10 vulnerabilties found",
                        align: "center",
                        verticalAlign: "middle",
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none'
                            }
                        },
                    },
                }
            }
        },
    },
    created() {
        const cmp = this;

        // register chart click actions
        const events = {
            dataPointSelection: function (event, chartContext, opts) {
                const selectedLabel = opts.w.config.labels[opts.dataPointIndex];

                const params = new URLSearchParams({
                    owasp: selectedLabel,
                    owasp_year: cmp.options.owasp.value
                });
                const href = '/vulnerabilities?' + params.toString();
                window.open(href, '_blank').focus();
            }
        };

        this.chartOptions.chart = this.chartOptions.chart || {};
        this.chartOptions.chart.events = {...this.chartOptions.chart.events, ...events};
    },
    methods: {
        parseData: function (data) {
            const cmp = this;
            this.chartSeries = data.data;

            this.chartOptions['title']['text'] = data.title;
            this.chartOptions['labels'] = data.labels;
            this.chartOptions['colors'] = data.colors;

            if (this.chartSeries.length === 0 || this.options.size.value === 'sm'|| this.portal.vertical) {
                this.chartOptions['legend']['show'] = false;
            } else {
                this.chartOptions['legend']['show'] = true;
            }

            // for some reason refreshing the chart normally doesn't work here...
            this.$refs.portletChart.updateSeries(this.chartSeries);
            this.$refs.portletChart.updateOptions(this.chartOptions);
        },
    },
    watch: {
        colSize: {
            handler: function (val, oldVal) {
                if (oldVal === val) {
                    return;
                }
                // force rerender of chart if component width changes
                this.refresh();
            },
        }
    },
    data: function () {
        return {
            options: {
                owasp: {
                    label: "OWASP",
                    type: "select",
                    default: "2025",
                    choices: [{
                        label: 'OWASP 2013',
                        value: 2013
                    }, {
                        label: 'OWASP 2017',
                        value: 2017
                    }, {
                        label: 'OWASP 2021',
                        value: 2021
                    }, {
                        label: 'OWASP 2025',
                        value: 2025
                    }]
                },
            }
        };
    },
});
